// eslint-disable-next-line import/named
import { Reservation, ReservationResponse } from "../coworkerApiCalls/Reservations/ReservationsTypes";
import { userResponseToIUser } from "./UserMapper";

const reservationResponseToReservation = (reservation: ReservationResponse): Reservation => {
  return {
    date: reservation.date,
    creationDate: reservation.creationDate,
    user: userResponseToIUser(reservation.user),
    priority: reservation.priority
  };
};

const reservationResponsesToReservations = (reservations: ReservationResponse[]): Reservation[] => {
  return reservations.map((reservation: ReservationResponse): Reservation => reservationResponseToReservation(reservation));
};

export { reservationResponseToReservation, reservationResponsesToReservations };